import React, { useRef } from "react";
import classes from "./FooterAnimationWrapper.module.scss";
import { CSSTransition } from "react-transition-group";
import { FooterMenus } from "./SolutionsNavigation";
import UserProfileMenu from "./UserProfileMenu";
import AdminSettingsMenu from "./AdminSettingsMenu";
import FooterMenu from "./FooterMenu";
import CustomerSwitcher from "./CustomerSwitcher";
import { useTranslation } from "react-i18next";

interface Props {
  openFooterMenu: FooterMenus;
}

const FooterAnimationWrapper: React.FC<Props> = ({ openFooterMenu }) => {
  const { t } = useTranslation();
  const ref = useRef(null);

  const TITLE_MAP = {
    [FooterMenus.UserProfile]: "solutions_navigation_my_profile_title",
    [FooterMenus.AdminSettings]: "solutions_navigation_admin_settings_title",
    [FooterMenus.CustomerSwitcher]:
      "solutions_navigation_company_switcher_title",
    [FooterMenus.Translations]: "Translations",
  };

  const animate = (): boolean => {
    return openFooterMenu !== null;
  };

  return (
    <CSSTransition
      classNames="animate-footer"
      nodeRef={ref}
      in={animate()}
      timeout={400}
      addEndListener={() => false}
    >
      <div className={classes.footerAnimationWrapper} ref={ref}>
        <FooterMenu title={t(TITLE_MAP[openFooterMenu] || " ")}>
          {openFooterMenu === FooterMenus.UserProfile && <UserProfileMenu />}
          {openFooterMenu === FooterMenus.AdminSettings && (
            <AdminSettingsMenu />
          )}
          {openFooterMenu === FooterMenus.CustomerSwitcher && (
            <CustomerSwitcher />
          )}
          {/* TODO: Someday we'll potentially have a Translation selector here */}
        </FooterMenu>
      </div>
    </CSSTransition>
  );
};

export default FooterAnimationWrapper;
